import Vue from 'vue'
import _ from 'lodash';
import store from './store';
import App from './App.vue';
import './styles/main.scss';
import router from './router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import NotifyMixin from "@/Util/NotifyMixin";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { dateFormat, handleSyncRequestLoader } from "@/Util/auth";
import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import he from './locales/he.json';
import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import CrudTable from "@/components/CrudTable";
import VueRecaptcha from 'vue-recaptcha';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import AOS from 'aos';
import 'aos/dist/aos.css';
Vue.use(CKEditor);



Vue.config.productionTip = false

Vue.component('crud-table', CrudTable);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueI18n);
Vue.component('vue-recaptcha', VueRecaptcha);
Vue.use(VuePhoneNumberInput, {
  mode: 'international',
  defaultCountry: 'IN',
  validCharactersOnly: true,
  inputOptions: {
    placeholder: 'Enter phone number'
  }
});
Vue.mixin({
  mounted() {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-in-out'
    })
  }
})

Vue.component('vue-phone-number-input', VuePhoneNumberInput);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    he
  }
});

// Add direction configuration
const directionConfig = {
  'en': 'ltr',
  'he': 'rtl'
};

// Add method to handle direction
Vue.prototype.$setDirection = function (locale) {
  document.documentElement.dir = directionConfig[locale] || 'ltr';
};

Vue.prototype._ = _;
Vue.prototype.$global = {
  dateFormat: (date, format = 'DD/MM/YYYY') => ((date) ? dateFormat(date, format) : null),
};

Vue.mixin(NotifyMixin);

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
  created() {
    handleSyncRequestLoader(store, process.env.VUE_APP_API_URL);
  },
}).$mount('#app')
